import { Box } from "@primer/react";
import { PaperAirplaneIcon, DownloadIcon } from "@primer/octicons-react";
import { useCallback, useEffect, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { PlaceHolder } from "../../components/ui/place-holder";
import Button from "../../components/ui/button";
import { sf_mucphaithu } from "../../models/response/thu-phi/sf_mucphaithu";
import { bienLaiThuApi } from "../../api/bienLaiApi";
import { DefaultPopup } from "../../components/modal";
import SendBienLaiModal from "../../components/thu-phi/send-bien-lai/SendBienLaiModal";

interface IPhieuThuViewPrintProps {
  sf_mucphaithu: sf_mucphaithu;
  onClose: () => void;
}
const DonHangViewPrint = (props: IPhieuThuViewPrintProps) => {
  const componentRef = useRef<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [isShowSendEmail, setIsShowSendEmail] = useState(false);

  const [htmlPrint, setHtmlPrint] = useState("");
  useEffect(() => {
    handleGetHtmlPrint();
  }, [props.sf_mucphaithu.id]);
  const handleGetHtmlPrint = async () => {
    setIsLoading(true);
    const data_send: any = {
      sf_mucphaithu_id: props.sf_mucphaithu.so_chung_tu.includes("CT")
        ? props.sf_mucphaithu.id
        : props.sf_mucphaithu.sf_mucphaithu_parent_id,
      sf_mucphaithu_root_id: props.sf_mucphaithu.id,
    };

    const res = await bienLaiThuApi.print(data_send);
    if (res.is_success) {
      setHtmlPrint(res.data);
    } else {
      setHtmlPrint("");
    }
    setIsLoading(false);
  };
  const onClose = useCallback(() => {
    window.animationHidePopup("");
    setTimeout(() => {
      props.onClose();
    }, 500);
  }, []);
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
  });
  const handleSendEmail = () => {
    setIsShowSendEmail(true);
  };
  return (
    <DefaultPopup
      // width={'70%'}
      title="Biên lai thu phí"
      onClose={onClose}
    >
      <Box>
        {htmlPrint && (
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                border: "1px dashed",
                borderColor: "border.default",
                borderRadius: 2,
                p: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  pb: 2,
                  mb: 2,
                  borderBottom: "1px solid",
                  borderColor: "border.muted",
                }}
              >
                <Box sx={{ flex: 1 }}>&nbsp;</Box>
                <Button
                  text="Gửi email"
                  sx={{ ml: 1, mr: 1 }}
                  leadingVisual={PaperAirplaneIcon}
                  onClick={() => {
                    handleSendEmail();
                  }}
                />
                <Button
                  text="In biên lai"
                  variant="primary"
                  sx={{ ml: 1, mr: 1 }}
                  leadingVisual={DownloadIcon}
                  onClick={() => {
                    handlePrint();
                  }}
                />
                {/* <Button text='In phiếu thu' variant='primary' sx={{ ml: 1, mr: 1 }} leadingVisual={DownloadIcon} /> */}
              </Box>
              <Box
                sx={{
                  width: "29.7cm",
                }}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: htmlPrint }}
                  ref={componentRef}
                ></div>
              </Box>
            </Box>
          </Box>
        )}
        {isShowSendEmail && (
          <SendBienLaiModal
            onClose={() => {
              setIsShowSendEmail(false);
            }}
            sf_mucphaithu={props.sf_mucphaithu}
            ts_hocsinh_id={props.sf_mucphaithu.ts_hocsinh_id}
          />
        )}
      </Box>
    </DefaultPopup>
  );
};

export default DonHangViewPrint;
